export const SELECT_ALL_VALUE = '__select_all__'

/**
 * Normalizes a multi-select value array when a synthetic "Select All" option is used.
 *
 * Expected behavior:
 * - If SELECT_ALL_VALUE is present:
 *   - If *all* real values are already selected -> clear selection ([]).
 *   - Otherwise -> select all real values.
 * - If SELECT_ALL_VALUE is not present -> return selection without changes.
 */
export function normalizeSelectAllSelection<T>(selection: T[] | null | undefined, allValues: T[]): T[] {
  const current = Array.isArray(selection) ? selection.slice() : []

  // If user didn't interact with Select All, keep as-is.
  if (!current.includes(SELECT_ALL_VALUE as unknown as T)) {
    return current
  }

  // Remove synthetic value from the selection.
  const withoutSelectAll = current.filter(v => v !== (SELECT_ALL_VALUE as unknown as T))

  // Toggle: if already all selected, clear; otherwise select all.
  const isAllSelected = allValues.length > 0 && allValues.every(v => withoutSelectAll.includes(v))
  return isAllSelected ? [] : allValues.slice()
}


